<template>
	<v-hover v-slot:default="{ hover }" close-delay="600">
		<v-col cols="4" md="3">
			<v-progress-linear rounded height="29px" :color="color" :value="rate"> 
				<span class="caption">{{theme}}: 
					{{rate}}%
				</span>
				<div style="position: absolute; right: 10px">						
					<v-btn icon small v-if="hover" @click="dialog = true"><v-icon>mdi-information</v-icon></v-btn>
				</div>
			</v-progress-linear>
			<v-dialog  width="399px" v-model="dialog">
				<v-card>
					<v-card-title>
						{{theme}}
					</v-card-title>
					<v-card-text>
						<slot name="content">	</slot>		
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn link to="/themes" color="primary" rounded>Mehr</v-btn>
					</v-card-actions>
				</v-card>					

			</v-dialog>
		</v-col>
	</v-hover>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	// import FancyTooltip from "@/components/elements/FancyTooltip"
	export default {
		name: "ThemeCompletionRate", 
		props: {
			theme: {},
			question: {},
			response: {}
		},
		data: () => {
			return {
				dialog: false
			}
		},
		components: {
			// FancyTooltip
		},
		computed: {
			rate(){
				return this.response.completion_rate[this.theme] || 0
			},
			color(){
				if( this.question && (this.theme == this.question.cn_theme) ){
					return "green";
				}
				else{
					return "grey";
				}				
			}
			// ...Vuex.mapState({})
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"